//Please add the language resource
const factory = {
  factoryNo:'factoryNo',
  factoryName:'factoryName',
  createTime:"createTime",
  creator:"creator",
  updateTime:"updateTime",
  updater:"updater",
  msg:{
  }
};
export default factory



// WEBPACK FOOTER //
// ./src/page/md/factory/lang/factory.en.js